<template>
  <!-- v-b-modal.id to call modal-->
  <b-modal
    :id="id"
    :modal-class="modalClass"
    :content-class="contentClass"
    :body-class="bodyClass"
    :dialog-class="dialogClass"
    :size="size"
    :ok-only="okOnly"
    :no-fade="noFade"
    :ok-title="okTitle"
    :centered="centered"
    :hide-footer="hideFooter"
    :hide-header="hideHeader"
    :scrollable="scrollable"
    :no-stacking="noStacking"
    :no-close-on-esc="noCloseOnEsc"
    :no-close-on-backdrop="noCloseOnBackdrop"
    @close="close"
  >
    <template #modal-header="{ close }">
      <!-- name of patient -->
      <b-container fluid>
        <b-row>
          <b-col>
            <h3 class="mb-0 text-primary">
              {{ title }}
            </h3>
          </b-col>
        </b-row>
      </b-container>
      <!-- Emulate built in modal header close button action -->
      <b-button
        v-if="showCloseButton"
        size="sm"
        variant="link"
        @click="close()"
      >
        <b-icon
          icon="x-circle-fill"
          variant="info"
        />
      </b-button>
    </template>
    <!-- custom content -->
    <slot></slot>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
    },
    modalClass: {
      type: String,
    },
    contentClass: {
      type: String,
    },
    bodyClass: {
      type: String,
    },
    dialogClass: {
      type: String,
    },
    size: {
      type: String,
    },
    title: {
      type: String,
    },
    centered: {
      type: Boolean,
      default: false,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    okTitle: {
      type: String,
      default: 'OK',
    },
    okOnly: {
      type: Boolean,
      default: false,
    },
    noStacking: {
      type: Boolean,
      default: false,
    },
    noCloseOnEsc: {
      type: Boolean,
      default: false,
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false,
    },
    noFade: {
      type: Boolean,
    },
    close: {
      type: Function,
      default: () => {},
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
/deep/.modal-header {
  border-bottom: 0;
  align-items: center;
}

/deep/.modal-footer {
  border-top: 0;
  align-items: center;
}

/deep/.terms-modal .modal-header {
  padding-left: 10px;
  padding-right: 10px;
  font-family: "hattonmedium";
  letter-spacing: initial;
}

/deep/.agreement .modal-content {
  background-color: #f8f4ff;
}

/deep/.agreement .modal-content h2 {
  padding: 1em;
  letter-spacing: 0;
}
</style>
